import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { IpAddressService, MessageService } from '@app/shared/services';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { StatusCrm, StatusCrmCss, StatusCrmLabel } from '@app/shared/enum';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InitStudentService } from '@app/student/services';
import { CustomValidators } from '@app/shared/validators/custom-validators';
import { IndicationService } from '@app/marketing/services';
import { Component, Input, OnInit } from '@angular/core';
import { Indication } from '@app/student/model';
import { default as swal } from 'sweetalert2';
import { Student } from '@app/admin/model';
import { Router } from '@angular/router';
import { User } from '@app/auth/model';
import { first } from 'rxjs/operators';
import { Options } from 'select2';

@Component({
  selector: 'student-new-indication',
  templateUrl: 'indication.component.html',
})
export class IndicationComponent implements OnInit {
  @Input('id') indicationId: number;
  @Input('preview') previewMode: boolean = false;

  public indicationForm: any;
  public submitted = false;
  private returnUrl: string = '/student/indications';
  public validIndication: boolean;
  public errorMessage = '';
  public closeResult: string;
  public listErrorMessage: any[];
  public cancelButtonText: string = 'Cancelar';

  public indication: Indication;

  public options: Options = {
    width: '300',
    allowClear: true,
  };

  public countryCode: string = '55'; // padrão Brasil
  public phone: string = '';
  public phoneMask: string = '';

  public newStatusCrm: any;
  public statusInitialValue: any;
  public newStatusCrmId: number;
  public newStatusCrmStr: string;
  public newStatusCrmCss: string;
  public statusCrmDataList: Array<any>;

  public messageLength: number = 0;
  public dateNow: Date = new Date();
  public initialValueDate: any;

  private student: Student;
  public user: User = new User();

  constructor(
    private initStudent: InitStudentService,
    private indicationService: IndicationService,
    private ipAddressService: IpAddressService,
    private formBuilder: FormBuilder,
    private loading: MessageService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.initStudent.setConfigPage(false, false);
    this.getStatusCrmList();
    this.onInitForm();
  }

  ngOnInit(): void {
    this.previewMode = JSON.parse(this.previewMode.toString());
    this.indicationId = JSON.parse(this.indicationId.toString());
    this.loading.showLoading();
    this.getUserData();
  }

  getUserData() {
    if (this.initStudent.user != null && this.initStudent.user.id > 0) {
      this.initStudent
        .getStudentUser()
        .pipe(first())
        .subscribe(
          (response: any) => {
            this.student = response;
            this.user = this.initStudent.user;
            this.initialyze();
          },
          (error: any) => {
            swal({
              type: 'error',
              title: 'Erro ao carregar a indicação!',
              showConfirmButton: false,
              timer: 2000,
            }).then((result) => {
              this.router.navigate([this.returnUrl]);
            });
          }
        );
    } else {
      this.initialyze();
    }
  }

  private initialyze() {
    if (this.indicationId > 0 && this.previewMode) {
      this.getIndicationById(this.indicationId);
    }

    //this.onSetEventsForm();
    this.loading.hideLoading();
  }

  getIndicationById(id: any) {
    this.loading.showLoading();
    this.indicationService
      .getById(id)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response.typeResponse == TypeResponse.Success) {
            this.validIndication = true;
            this.designChangeStatus(response.data);
            this.setFormByEntity(response.data);
          } else {
            this.errorMessage = response.message;
          }
          this.loading.hideLoading();
        },
        (error: any) => {
          if (error.error.error === 'invalid_token') {
            this.router.navigate(['/auth/login']);
          }
        }
      );
  }

  setNewStatus(value: any) {
    this.newStatusCrmId = Number.parseInt(value);
    this.newStatusCrm = this.statusCrmDataList.find((x: any) => x.id == value);
    this.newStatusCrmStr = StatusCrmLabel.get(value);
    this.newStatusCrmCss = StatusCrmCss.get(value);
    this.statusInitialValue = this.newStatusCrm;
  }

  getStatusCrmList() {
    const statusList: Array<object> = [];
    for (var value in StatusCrm) {
      if (Number.isInteger(Number.parseInt(value))) {
        statusList.push({
          value: Number.parseInt(value),
          text: StatusCrmLabel.get(Number.parseInt(value)),
        });
      }
    }
    this.statusCrmDataList = this.getTemplateStatusList(statusList);
    this.setNewStatus(StatusCrm.Indication);
  }

  getTemplateStatusList(data: Array<any>): any[] {
    if (data != null && data.length > 0) {
      let arrayStatusList: Array<any> = new Array<any>();
      for (let i = 0; i < data.length; i++) {
        const element: any = {
          id: data[i].value,
          name: data[i].text,
        };
        arrayStatusList.push(element);
      }
      return arrayStatusList;
    }
    return new Array<any>();
  }

  onInitForm() {
    this.validIndication = true;
    this.indicationForm = this.formBuilder.group({
      id: [0],
      name: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(5),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.maxLength(150),
          Validators.minLength(5),
        ],
      ],
      phone: ['', [Validators.required, Validators.maxLength(15)]],
      message: ['', [Validators.required]],
      statusCrm: [this.newStatusCrmId, [Validators.required]],
      experimentalClassTeacherId: [],
      ipAddress: [''],
      createdOn: [''],
      updatedOn: [''],
      experimentalClass: [''],
      status: [0],
    });

    this.setNewStatus(StatusCrm.Indication);
  }

  // onSetEventsForm() {
  //   this.f.phone.valueChanges.subscribe((value: string) => {
  //     var strPhone = value
  //       .toString()
  //       .replace('(', '')
  //       .replace(')', '')
  //       .replace('-', '')
  //       .replace('_', '')
  //       .replace(' ', '');
  //     var phoneNumber = parseInt(strPhone);
  //     if (!(phoneNumber >= 0 && phoneNumber <= 99999999999)) {
  //       value = phoneNumber.toString();
  //       this.f.phone.status = 'INVALID';
  //     }
  //   });
  // }

  get f() {
    if (this.indicationForm) {
      return this.indicationForm.controls;
    }
    return null;
  }

  getControl(controlName: string) {
    return this.indicationForm.get(controlName);
  }

  getFormattedMessage(messageValue: string): any {
    return messageValue?.replace(/\n/g, '<br />');
  }

  onSubmit() {
    this.loading.showLoading();
    this.submitted = true;
    this.validIndication = true;

    // Errors Cleaning
    this.errorMessage = '';

    // stop here if form is invalid
    if (this.indicationForm.invalid) {
      this.loading.hideLoading();
      this.submitted = false;
      this.validIndication = false;
      this.errorMessage = 'Informe todos os campos para continuar.';
      return;
    }

    this.indication = new Indication(this.indicationForm.value);
    if (!this.previewMode) {
      this.ipAddressService.getIPAddress().subscribe((ip: string) => {
        this.indication.ipAddress = ip;
        console.log('Endereço IP:', ip);

        this.indication.userGuid = this.user.userId;

        this.indicationService
          .save(this.indication)
          .pipe(first())
          .subscribe(
            (dataReturn: any) => {
              if (dataReturn.typeResponse == TypeResponse.Success) {
                this.validIndication = true;
                swal({
                  type: 'success',
                  title: 'Indicação registrada com sucesso!',
                  showConfirmButton: false,
                  timer: 1500,
                }).then((result) => {
                  this.dismissModal();
                  window.location.reload();
                });
              } else {
                this.validIndication = false;
                this.errorMessage = dataReturn.message;
                if (
                  dataReturn.data &&
                  dataReturn.data.errors &&
                  dataReturn.data.errors.length > 0
                ) {
                  this.listErrorMessage = [];
                  for (var i = 0; i <= dataReturn.data.errors.length; i++) {
                    this.listErrorMessage.push(
                      dataReturn.data.errors[i].Description
                    );
                  }
                }
              }
              this.submitted = false;
              this.loading.hideLoading();
            },
            (error: any) => {
              this.validIndication = false;
              this.submitted = false;
              this.dismissModal();
              this.loading.hideLoading();
              this.errorMessage = error.message;
              if (error.status >= 400) {
                this.errorMessage = error.error.message;
              }
            }
          );
      });
    }
  }

  onPhoneInput(event: any) {
    const ctrl = this.indicationForm.get('phone');
    if (!ctrl) return;

    // remove caracteres não numéricos
    let valor = event.target.value.replace(/\D/g, '');

    // aplica a formatação
    valor = this.formatPhone(valor);

    // atualiza o valor do formControl sem emitir evento (para evitar loop)
    ctrl.setValue(valor, { emitEvent: false });
    // também atualiza o valor do input manualmente
    event.target.value = valor;
  }

  formatPhone(valor: string): string {
    if (valor.length <= 10) {
      // fixo ou celular sem DDI, ex: (11) 1234-5678
      valor = valor.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
      // se estiver incompleto, coloca os parênteses e espaço
      valor = valor.replace(/^(\d{2})(\d{0,4})(\d{0,4})$/, '($1) $2$3');
    } else {
      // celular com 11 dígitos, ex: (11) 91234-5678
      valor = valor.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
    return valor;
  }

  onCancel(): void {
    this.dismissModal();
    this.router.navigate([this.returnUrl]);
  }

  designChangeStatus(item: any) {
    if (item?.contactBySiteStatusChanges) {
      item.contactBySiteStatusChanges.forEach(function (e: any) {
        if (e.oldStatus >= 0) {
          let oldStatusStr = StatusCrmLabel.get(e.oldStatus);
          let oldStatusCss = StatusCrmCss.get(e.oldStatus);
          e.designOldStatus =
            "<span class='badge w-100 " +
            oldStatusCss +
            " badge-pill py-1 px-3'>" +
            oldStatusStr +
            '</span>';
        }

        if (e.newStatus >= 0) {
          let newStatusStr = StatusCrmLabel.get(e.newStatus);
          let newStatusCss = StatusCrmCss.get(e.newStatus);
          e.designNewStatus =
            "<span class='badge w-100 " +
            newStatusCss +
            " badge-pill py-1 px-3'>" +
            newStatusStr +
            '</span>';
        }
        e.datetime = new Date(e.createdOn);
      });
    }
    this.setFormByEntity(item);
  }

  setFormByEntity(data: any) {
    this.indication = new Indication(data);

    this.indicationForm = this.formBuilder.group({
      name: new FormControl(this.indication.name),
      email: new FormControl(this.indication.email),
      phone: new FormControl(this.indication.phone),
      message: new FormControl(this.indication.message),
      ipAddress: new FormControl(this.indication.ipAddress),
    });
    this.setNewStatus(StatusCrm.Indication);
  }

  dismissModal() {
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === 3) {
      return 'by opening next modal';
    } else {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else if (reason === 2) {
        return 'by clicking on a close button';
      } else {
        return `with: ${reason}`;
      }
    }
  }

  countMessageLength(input: any) {
    this.messageLength = input.target.value.length;
  }
}
